import React from 'react';

const Section = React.forwardRef(({ id, className = '', children }, ref) => {
    return (
        <section
            id={id}
            className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${className}`}
            ref={ref}
        >
            <div className="max-w-7xl mx-auto">
                {children}
            </div>
        </section>
    );
});

Section.displayName = 'Section';

export default Section;
